import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Card } from "@/components/ui/card";
import { Package, UploadSimple, CreditCard, Bell, UsersThree } from "@phosphor-icons/react";

const stat = (label, value, Icon, testid) => (
  <Card className="rounded-sm bg-[#141414] border-[#262626] p-6 flex flex-col gap-4 hover:-translate-y-0.5 hover:border-[#404040] transition-transform" data-testid={testid}>
    <div className="flex items-center justify-between">
      <div className="text-[10px] uppercase tracking-widest text-[#71717A]">{label}</div>
      <Icon size={16} weight="bold" className="text-[#A1A1AA]" />
    </div>
    <div className="font-display text-4xl font-black tracking-tight">{value}</div>
  </Card>
);

export default function Dashboard() {
  const { user } = useAuth();
  const [stats, setStats] = useState({ users: 0, items: 0, files: 0, transactions: 0, notifications: 0 });

  useEffect(() => {
    api.get("/stats").then((r) => setStats(r.data)).catch(() => {});
  }, []);

  return (
    <div className="p-8 max-w-7xl">
      <header className="mb-8 pb-6 border-b border-[#262626]">
        <div className="text-[10px] uppercase tracking-widest text-[#71717A] mb-2">Overview</div>
        <h1 className="font-display text-4xl font-black tracking-tight">
          Welcome, {user?.name || user?.email?.split("@")[0]}
        </h1>
        <p className="text-sm text-[#A1A1AA] mt-2">
          Live snapshot of your workspace. All endpoints are prefixed with{" "}
          <code className="font-mono text-white bg-[#141414] px-1.5 py-0.5">/api</code>.
        </p>
      </header>

      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4 mb-10">
        {user?.role === "admin" && stat("Users", stats.users, UsersThree, "stat-users")}
        {stat("Items", stats.items, Package, "stat-items")}
        {stat("Files", stats.files, UploadSimple, "stat-files")}
        {stat("Transactions", stats.transactions, CreditCard, "stat-transactions")}
        {stat("Unread notifications", stats.notifications, Bell, "stat-notifications")}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Card className="rounded-sm bg-[#141414] border-[#262626] p-6">
          <div className="text-[10px] uppercase tracking-widest text-[#71717A] mb-3">API Reference</div>
          <h3 className="font-display text-xl font-bold mb-4">Endpoints available</h3>
          <ul className="space-y-2 text-sm font-mono text-[#A1A1AA]">
            <li><span className="text-[#0055FF]">POST</span> /api/auth/login</li>
            <li><span className="text-[#10B981]">GET</span>  /api/items</li>
            <li><span className="text-[#0055FF]">POST</span> /api/files/upload</li>
            <li><span className="text-[#0055FF]">POST</span> /api/payments/checkout</li>
            <li><span className="text-[#0055FF]">POST</span> /api/ai/ask</li>
            <li><span className="text-[#10B981]">GET</span>  /api/notifications</li>
          </ul>
        </Card>
        <Card className="rounded-sm bg-[#141414] border-[#262626] p-6">
          <div className="text-[10px] uppercase tracking-widest text-[#71717A] mb-3">Integrations</div>
          <h3 className="font-display text-xl font-bold mb-4">Wired services</h3>
          <ul className="space-y-2 text-sm text-[#A1A1AA]">
            <li className="flex justify-between"><span>JWT + bcrypt auth</span><span className="text-[#10B981] font-mono text-xs">LIVE</span></li>
            <li className="flex justify-between"><span>OpenAI GPT-5.2</span><span className="text-[#10B981] font-mono text-xs">LIVE</span></li>
            <li className="flex justify-between"><span>Stripe payments</span><span className="text-[#10B981] font-mono text-xs">TEST</span></li>
            <li className="flex justify-between"><span>SendGrid email</span><span className="text-[#F59E0B] font-mono text-xs">MOCKED</span></li>
            <li className="flex justify-between"><span>Twilio WhatsApp</span><span className="text-[#F59E0B] font-mono text-xs">MOCKED</span></li>
            <li className="flex justify-between"><span>Object Storage</span><span className="text-[#10B981] font-mono text-xs">LOCAL</span></li>
          </ul>
        </Card>
      </div>
    </div>
  );
}
